/** Raw color palette, mirrors `src/styles/variables.less`. Only consumed by `semantic.ts` — don't add new colors here directly. */ export var palette = {
    textDarkGray: '#313131',
    textMediumGray: '#505050',
    textShadowedGray: '#808080',
    primaryBg: '#ecedf4',
    primaryRed: '#7d0c0c',
    primaryPurple: '#5b5fc7',
    primaryGreen: '#5a9e3a',
    primaryBlue: '#0078d4',
    primaryDarkPurple: '#444691',
    borderBright: '#eaeae9',
    borderShadowWhite: '#f0f0f0',
    secondaryRed: '#860404',
    primaryPink: '#d8c5e0',
    secondaryPink: '#e3008c',
    secondaryGreen: '#6bb700',
    darkItemBg: 'rgb(45, 44, 44)',
    /** Not in variables.less, but the semantic layer needs it. */ white: '#ffffff',
    /** Destructive-button red — distinct from `primaryRed`, which is menu-item text only. */ dangerRed: '#B30F04',
    /**
   * Not in variables.less. The brand's second color (favicon, splash `--splash-color1`,
   * `msapplication-TileColor` are all this hex) — the pink end of the AI gradient, whose purple
   * end is `primaryDarkPurple`. Deliberately NOT `secondary*`: those keys are unrelated colors,
   * and "secondary" in `theme.light.ts` means TFButton's neutral-gray variant.
   */ brandAccent: '#DA335E',
    /** Design's `Color-Secondary-*` / `Color-Primary-*` scale — the pastel ends of the subtle AI gradients (`Gradient-100`, `Gradient-200`). */ brandAccent100: '#F9CCDA',
    brandPurple100: '#D1D8FF',
    brandAccent200: '#F3A4BC',
    brandPurple200: '#BBC3FF',
    // Not in variables.less — Northstar's default theme colors, already used as inline hex across the app.
    textCharcoal: '#252423',
    textDisabledGray: '#c8c6c4',
    neutralGrayLight: '#EDEBE9',
    neutralGrayMedium: '#E1DFDD',
    transparentGrayHover: '#e9e9e9',
    lightPurple: '#b2b3d2',
    /** Northstar teams theme's brand[800] — real `<Button primary>` pressed background (`primaryPurple`/`primaryDarkPurple` are brand[600]/[700], rest/hover). */ primaryPurplePressed: '#3d3e78',
    /** TFText's most common text-color override — a third muted-gray role, distinct from `textMediumGray`/`textShadowedGray`. */ textMutedGray: '#9A9A9A',
    /** TFText's canonical danger red, distinct from `dangerRed` (TFButton's danger border/text) — this is the TEXT-context red. */ dangerRedText: '#FF1606',
    /** TFText's success color — one digit off `secondaryGreen` (kept separate, not force-unified) and unrelated to `primaryGreen`. */ textSuccessGreen: '#6BB701',
    /** TFText's warning color. */ textWarningOrange: '#FFAA44',
    /**
   * The amber notice trio — a tinted surface with its own foregrounds, which is why they are three
   * keys rather than one: the icon sits one shade darker than the text on purpose. Unrelated to
   * `textWarningOrange` (TFText's warning), which is a foreground on the app's white surface and
   * unreadable on this tint. From `MeetingIntelligenceBox.less`'s transcription hint.
   */ warningAmberBg: '#fff7ec',
    warningAmberIcon: '#b37730',
    warningAmberText: '#9c6829',
    // ---- Dark-mode values consumed by theme.dark.ts ----
    /** `MeetingIntelligenceBox.less`'s `boxBackgroundColor` — the app's only existing real dark surface. */ darkSurface: '#282727',
    /** One step lighter than `darkSurface`; no existing dark hover state to copy from. */ darkSurfaceHover: '#3a3939',
    /** One step darker than `darkSurface`. */ darkSurfacePressed: '#201f1f',
    /** Visible-but-quiet border against `darkSurface`. */ darkBorder: '#4a4949',
    /** Dimmer than `darkBorder`, for the disabled state. */ darkBorderDisabled: '#363535',
    /** Translucent white so it reads on `darkSurface` without a hand-picked hex. */ darkForegroundDisabled: 'rgba(255, 255, 255, 0.4)',
    /** Northstar's `subtle`/`outline` hover fill, inverted for dark. */ darkTransparentHover: 'rgba(255, 255, 255, 0.08)',
    /** Same idea, pressed. */ darkTransparentPressed: 'rgba(255, 255, 255, 0.15)',
    /** `dangerRed` is too low-contrast on `darkSurface`; this reads correctly on dark. */ darkDangerRed: '#ff6b6b',
    /** The warning notice's fill on `darkSurface` (design) — a neutral block, not an amber tint. */ darkNoticeSurface: '#505050',
    /** Design's dark-theme AI gradient (Figma): lighter ends so the gradient reads on `darkSurface`. */ darkAiAccent: '#EC7D9D',
    darkAiPurple: '#969EF1'
};
